<template>
    <div>
        <div v-show='show' class='layer-pop square'>
            <div class='view-content small-padding' style='width: auto; max-width: 90vw'>
                <button class='close' @click='onClosePop'>
                    <span class='blind'>Popup Close</span>
                </button>
                <div class='com-scroll-y'>
                    <p class='pop-tit'>계약서 서명하기</p>
                    <div style='display: flex'>
                        <div class='contract-container' style='margin-top: 15px; margin-left: 0'>
                            <div class='contract-content' style='position: relative; padding: 0'>
                                <div class='carousel-indicator top-position'>
                                    <div class='carousel-indicator-pagination'>{{(data.contractInfo == null ? 0 : 1) + "/1"}} 페이지</div>
                                    <select-form
                                        class='contract-send-percent'
                                        :select-data="['25%', '50%', '70%', '100%', '120%', '150%']"
                                        :select-value='[25, 50, 70, 100, 120, 150]'
                                        :selected-value='contractZoom'
                                        @update:set='val => contractZoom = val'
                                    ></select-form>
                                </div>
                                <el-carousel
                                    ref="carousel"
                                    trigger="click"
                                    :interval="1000"
                                    :arrow="'none'"
                                    :autoplay="autoPlay"
                                    :indicator-position="'none'"
                                    style="height: 500px;"
                                >
                                    <el-carousel-item
                                        style='padding: 30px'
                                    >
                                        <div class='contract-title-input' style='margin-bottom: 20px; background-color: transparent'
                                            :style='`font-size: ${16 * contractZoom / 100}px`'>
                                            {{data.contractInfo == null ? "" : data.contractInfo.e_contract_title}}
                                        </div>
                                        <div class='contract-info-title' :style='`font-size: ${16 * contractZoom / 100}px`'>수신인 정보</div>
                                        <div style='display: flex'>
                                            <div class='contract-info-sub-title title' :style='`font-size: ${14 * contractZoom / 100}px`'>이름</div>
                                            <div class='contract-info-sub-title' :style='`font-size: ${14 * contractZoom / 100}px`'>{{data.info.customerName}}</div>
                                        </div>
                                        <div style='display: flex'>
                                            <div class='contract-info-sub-title title' :style='`font-size: ${14 * contractZoom / 100}px`'>연락처</div>
                                            <div class='contract-info-sub-title' :style='`font-size: ${14 * contractZoom / 100}px`'>{{data.info.customerPhone | phoneNumberFilter}}</div>
                                        </div>
                                        <div class='contract-info-title' v-show='data.info.templateType == "M" && data.ticketInfo' :style='`font-size: ${16 * contractZoom / 100}px`'>계약 정보</div>
                                        <div v-show='data.ticketInfo.length > 0' class='ticket-container'>
                                            <div class='ticket-box'>
                                                <div class='ticket-box-title' :style='`font-size: ${14 * contractZoom / 100}px`'>{{data.ticketInfo.length > 0 ? data.ticketInfo[0].title : ""}}</div>
                                                <div class='ticket-box-info' :style='`font-size: ${13 * contractZoom / 100}px`'>
                                                    <div style='flex: 1'>
                                                        {{data.ticketInfo.length > 0 ? data.ticketInfo[0].period : ""}}
                                                    </div>
                                                    <div>
                                                        {{data.ticketInfo.length > 0 ? data.ticketInfo[0].price : ""}}원
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-show='data.ticketInfo.length > 1' class='ticket-container'>
                                            <div class='ticket-box'>
                                                <div class='ticket-box-title' :style='`font-size: ${14 * contractZoom / 100}px`'>{{data.ticketInfo.length > 1 ? data.ticketInfo[1].title : ""}}</div>
                                                <div class='ticket-box-info' :style='`font-size: ${13 * contractZoom / 100}px`'>
                                                    <div style='flex: 1'>
                                                        {{data.ticketInfo.length > 1 ? data.ticketInfo[1].period : ""}}
                                                    </div>
                                                    <div>
                                                        {{data.ticketInfo.length > 1 ? data.ticketInfo[1].price : ""}}원
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-show='data.ticketInfo.length > 2' class='ticket-container'>
                                            <div class='ticket-box'>
                                                <div class='ticket-box-title' :style='`font-size: ${14 * contractZoom / 100}px`'>{{data.ticketInfo.length > 2 ? data.ticketInfo[2].title : ""}}</div>
                                                <div class='ticket-box-info' :style='`font-size: ${13 * contractZoom / 100}px`'>
                                                    <div style='flex: 1'>
                                                        {{data.ticketInfo.length > 2 ? data.ticketInfo[2].period : ""}}
                                                    </div>
                                                    <div>
                                                        {{data.ticketInfo.length > 2 ? data.ticketInfo[2].price : ""}}원
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class='contract-info-title' :style='`font-size: ${16 * contractZoom / 100}px`'>약관</div>
                                            <div style='padding: 10px 10px 0 10px' v-for='(it, i) in (data.contractInfo == null ? [] : data.contractInfo.templateInfo)'>
                                                <div v-if='it.type == 1'>
                                                    <div class='contract-info-sub-title' style='display: flex'>
                                                        <input style='flex: 1; border: none' v-model='it.title' :style='`font-size: ${14 * contractZoom / 100}px`'>
                                                    </div>
                                                    <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent' :style='`font-size: ${14 * contractZoom / 100}px`' v-model='it.content' @change='onChangeItemContent()'></textarea>
                                                </div>
                                                <div v-else style='display: flex'>
<!--                                                    <div class='com-check' style='margin-top: 12px'>-->
<!--                                                        <input-->
<!--                                                            :id='`agree-check-sign-${i}`'-->
<!--                                                            name='check-c1'-->
<!--                                                            v-model='it.checked'-->
<!--                                                            type='checkbox'-->
<!--                                                        />-->
<!--                                                        <label :for='`agree-check-sign-${i}`' class='agree-option'></label>-->
<!--                                                    </div>-->
                                                    <div style='flex: 1;'>
                                                        <div class='contract-info-sub-title' style='display: flex'>
                                                            <input style='flex: 1; border: none' v-model='it.title' :style='`font-size: ${14 * contractZoom / 100}px`' />
                                                        </div>
                                                        <textarea class='contract-info-sub-title area' :style='`font-size: ${14 * contractZoom / 100}px`' v-model='it.content' style='resize: none; background-color: transparent' @change='onChangeItemContent()'></textarea>
                                                        <div v-for='(jt, j) in it.options' style='display: flex; align-items: center; margin-top: 10px'>
                                                            <div class='com-check'>
                                                                <input
                                                                    :id='`agree-check-sign-${i}-${j}`'
                                                                    name='check-c1'
                                                                    type='checkbox'
                                                                    v-model='jt.checked'
                                                                />
                                                                <label :for='`agree-check-sign-${i}-${j}`' class='agree-option border-red'><div v-show='it.requiredFlag' class='check-required'>*</div></label>
                                                            </div>
                                                            <input v-model='jt.title' class='agree-option-input' :style='`font-size: ${14 * contractZoom / 100}px`' />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style='display: flex'>
                                            <div class='contract-info-title' style='flex: 1;' :style='`font-size: ${16 * contractZoom / 100}px`'>{{new Date() | dateFormatFilter2}}</div>
                                            <div style='width: 280px; margin-top: 40px;'>
                                                <div style='display: flex; align-items: center; cursor: pointer'>
                                                    <div class='contract-info-person' :style='`font-size: ${14 * contractZoom / 100}px`'>수신인: {{data.info.customerName}}</div>
                                                    <div @click='onShowRecipientSignature' class='contract-info-signature no-image border-red' v-show='recipientSignImageRawData == ""' :style='`font-size: ${14 * contractZoom / 100}px`'>(서명)</div>
                                                    <img @click='onShowRecipientSignature' class='contract-info-signature' v-show='recipientSignImageRawData != ""' :src='recipientSignImageRawData' />
                                                </div>
                                                <div style='display: flex; align-items: center; margin-top: 10px; cursor: pointer'>
                                                    <div class='contract-info-person' :style='`font-size: ${14 * contractZoom / 100}px`'>발신인: {{data.info.centerName}}</div>
                                                    <div @click='onShowSenderSignature' class='contract-info-signature no-image border-red' v-show='senderSignImageRawData == ""' :style='`font-size: ${14 * contractZoom / 100}px`'>(서명)</div>
                                                    <img class='contract-info-signature' v-show='senderSignImageRawData != ""' :src='senderSignImageRawData' />
                                                </div>
                                            </div>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </div>
                    </div>
                    <div class='bottom-btn' style='margin-top: 30px; padding-bottom: 0'>
                        <button class='com-btn white' @click='onCancel'>취소</button>
                        <button class='com-btn' @click='onComplete'>완료</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="signaturePop" class="layer-pop square">
            <div class="view-content small-padding" style='width: auto; max-width: 90vw'>
                <button class="close" @click="closeSignaturePopup">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style='font-size: 18px; margin-bottom: 15px;'>서명을 입력해주세요.</p>
                    <canvas class='signature-container' id='canvas_signature_sign_pad' width='500' height='400'></canvas>
                    <div class="bottom-btn" style='margin-top: 30px; padding-bottom: 0'>
                        <button class="com-btn white" @click="onReInput">다시입력</button>
                        <button class="com-btn white" @click="onCancelSignature">취소</button>
                        <button class="com-btn" @click="onInputComplete">입력완료</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import SignaturePad from 'signature_pad'
import { Utils } from '@/assets/js/utils';

export default {
    name: 'PersonallySignDlg',
    props: {
        show: Boolean,
        data: Object,
        close: Function,
        complete: Function,
    },
    watch: {
    },
    data() {
        return {
            centerId: 0,

            signaturePop: false,
            signaturePad: null,
            autoPlay: false,
            contractZoom: 100,

            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data

            senderFileGroupId: this.data.senderFileGroupId,
            senderSignImageRawData: this.data.senderSignImageRawData,
            senderBase64data: "",

            recipientSignImageRawData: "",
            recipientBase64data: "",

            type: 1,                // 1: sender sign, 2: recipient sign
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const {getters} = this.$store;
            return getters['auth/staffId'];
        },
    },
    methods: {
        async init() {
            this.centerId = parseInt(this.cId); // 센터id

            this.setSignaturePad();
            this.autoHeightTextArea();
        },

        setSignaturePad() {
            const canvas = document.querySelector("#canvas_signature_sign_pad");
            this.signaturePad = new SignaturePad(canvas);

            this.signaturePad.addEventListener("endStroke", () => {
                const file = Utils.getFileFromRawImageData(this.signaturePad.toDataURL());
                this.setUploadFile(file)
            }, { once: false });
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        async setUploadFile(file) {
            let base64data = await this.readFileAsync(file);
            if (this.type == 1) {
                this.senderBase64data = base64data; // 이미지 미리보기
            } else {
                this.recipientBase64data = base64data; // 이미지 미리보기
            }
            base64data = base64data.split(',')[1];
            if (base64data === undefined) {
                alert('빈 파일들은 추가할 수 없습니다.');
                return;
            }
            const fileInfo = {
                filename: file.name,
                mimetype: file.type,
                base64data: base64data,
                type: this.type,
            };

            if (this.type == 1) {
                this.senderFileGroupId = 0;
            } else {
            }

            this.uploadFiles = this.uploadFiles.filter(it => it.type != this.type);

            this.uploadFiles.push(fileInfo);
        },

        onClosePop() {
            this.close();
        },

        onShowRecipientSignature() {
            this.type = 2;

            this.showSignaturePopup();
        },

        onShowSenderSignature() {
            this.type = 1;

            this.showSignaturePopup();
        },

        showSignaturePopup() {
            this.signaturePop = true
        },

        closeSignaturePopup() {
            this.signaturePop = false
        },

        onCancel() {
            // 필수동의 체크 초기화
            if (this.data && this.data.contractInfo && this.data.contractInfo.templateInfo) {
              this.data.contractInfo.templateInfo.map(it => {
                if (it.type === 2 && it.requiredFlag) {
                  if (it.options) {
                    it.options.map(jt => {
                      jt.checked = false;
                    })
                  }
                }
              })
            }
            this.onClosePop();
        },

        autoHeightTextArea() {
            setTimeout(() => {
                let areas = document.querySelectorAll("textarea");
                for (var i = 0; i < areas.length; i++) {
                    areas.item(i).style.height = "auto"
                    areas.item(i).style.height = areas.item(i).scrollHeight + "px"
                }
            }, 10)
        },

        async onComplete() {
            if (!this.onCheckOption()) {    // 필수 동의/선택 항목을 모두 체크했는지 확인
              alert("필수 동의/선택을 체크해 주세요.")
              return;
            }

            const senderSign = this.uploadFiles.filter(it => it.type === 1)
            if (this.senderFileGroupId === 0 && senderSign.length === 0) { // 발송인 서명이미지가 있는지 확인
                alert("발송인 서명을 입력해 주세요.")
                return;
            }

            const recipientSign = this.uploadFiles.filter(it => it.type === 2)
            if (recipientSign.length === 0) { // 수신인 서명이미지가 있는지 확인
              alert("수신인 서명을 입력해 주세요.")
              return;
            }

            if (confirm('계약서 발송 시 건당 금액이 부과 됩니다. 계약서를 발송 하시겠습니까?')) {
                this.complete(this.data, this.uploadFiles);
            }
        },

        onReInput() {
            this.signaturePad.clear();
            if (this.type == 1) {
                this.senderBase64data = "";
            } else {
                this.recipientBase64data = "";
            }
            this.uploadFiles = this.uploadFiles.filter(it => it.type !== this.type);
        },

        onCancelSignature() {
            this.signaturePad.clear();
            if (this.type == 1) {
              this.senderBase64data = "";
            } else {
              this.recipientBase64data = "";
            }
            this.uploadFiles = this.uploadFiles.filter(it => it.type !== this.type);

            this.closeSignaturePopup();
        },

        onInputComplete() {
            if (this.type === 1) {
                this.senderSignImageRawData = this.senderBase64data
            } else {
                this.recipientSignImageRawData = this.recipientBase64data
            }

            this.signaturePad.clear();
            this.closeSignaturePopup();
        },

        getNowDatetime() {
            return moment().format('YYYY-MM-DD');
        },

        onChangeItemContent() {
            this.autoHeightTextArea();
        },

        onCheckOption() {
            let flag = true;
            if (this.data && this.data.contractInfo && this.data.contractInfo.templateInfo) {
                this.data.contractInfo.templateInfo.map(it => {
                  console.log(it);
                    if (it.type === 2 && it.requiredFlag) {
                        // if (!it.checked) flag = false;
                        if (it.options) {
                          let checkCount = 0;
                          it.options.map(jt => {
                            if (jt.checked) checkCount ++;
                          })
                          if (checkCount === 0 && it.options.length > 0) {
                            flag = false;
                          }
                        }
                    }
                })
            }

            return flag;
        },
    },
};
</script>
